export default {
  getIsOffline (state) {
    return state.isOffline
  }
}